<template>
    <div class="table-pagination">
        <div class="pagination-btn">
            <el-button 
                type="primary"
                @click="handleExport"
                v-if="needExport">
                全部導出
            </el-button>
            <el-button 
                type="danger"
                @click="handleDel"
                v-if="needDel">
                批量删除
            </el-button>
        </div>
     <!--   <el-pagination
            layout="prev, pager, next"
            :current-page="currentPage"
            :page-count="pageCount"
            @current-change="handleCurrent"
            background
            class="pagination-component">
        </el-pagination> -->
    </div>
</template>

<script>
    export default {
        props: {
            currentPage: {
                type: Number,
                default: 1
            },
            pageCount: {
                type: Number,
                default: 1
            },
            needExport: {
                type: Boolean,
                default: false
            },
            needDel: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            handleCurrent(current){
                this.$emit('current-change', current)
            },
            handleExport() {
                this.$emit('handle-export')
            },
            handleDel() {
                this.$emit('handle-del')
            }
        },
    }
</script>

<style scoped>
.table-pagination {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.pagination-btn {
    flex: 1;
    padding-left: 10px;
}

.pagination-component {
    flex-shrink: 0;
}
</style>